import React from "react";
import PropTypes from "prop-types";

import "./GenericErrorPage.css";
import Link from "components/shared/Link/Link";

import localize from "lang/localize";

const propTypes = {
  routeUrl: PropTypes.string,
  routeName: PropTypes.string,
  message: PropTypes.string,
  isBackRoute: PropTypes.bool,
  messageList: PropTypes.array,
  endMessage: PropTypes.string,
  language: PropTypes.string
};

const defaultProps = {
  isBackRoute: true,
  messageList: [],
  endMessage: ""
};

const GenericErrorPage = props => {
  const renderMessageList = messageList => {
    if (Array.isArray(messageList) && messageList.length > 0) {
      return (
        <div className="flex justify-content-center topmargin-10">
          <ul className="ul-default list-style-position-inside">
            {messageList.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  };

  const renderRouteUrl = () => {
    if (props.routeUrl) {
      return (
        <div className="pure-u-g">
          <div className="pure-u-1-1 textcenter topmargin-30">
            <Link
              to={props.routeUrl}
              className="button cta inline-block button-error"
            >
              {/* Using div here for convenient access to display: block */}
              <div className="text-truncated">
                {props.isBackRoute
                  ? localize("back_button_text_start", props.language).format(
                      props.routeName
                    )
                  : props.routeName}
              </div>
            </Link>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  const renderEndMessage = () => {
    if (
      typeof props.endMessage === "string" &&
      props.endMessage.trim() !== ""
    ) {
      return <h6 className="topmargin-30">{props.endMessage}</h6>;
    } else {
      return null;
    }
  };

  return (
    <div className="container verticalpadding">
      <div className="innerblock textcenter">
        <h6>
          {props.message
            ? props.message
            : localize("unavailable_resource", props.language)}
        </h6>
        {renderMessageList(props.messageList)}
        {renderEndMessage()}
        {renderRouteUrl()}
      </div>
    </div>
  );
};

GenericErrorPage.propTypes = propTypes;
GenericErrorPage.defaultProps = defaultProps;

export default GenericErrorPage;
